import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import './ProductDetail.css';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProduct = async () => {
    try {
      const { data } = await api.get(`/products/${id}`);
      setProduct(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching product:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!product) {
    return <div className="container"><p>Product not found</p></div>;
  }

  return (
    <div className="product-detail">
      <div className="container">
        <div className="product-detail-content">
          <div className="product-images">
            <img 
              src={product.images && product.images[0] ? product.images[0] : '/placeholder.jpg'} 
              alt={product.name} 
            />
          </div>

          <div className="product-details">
            <h1>{product.name}</h1>
            <p className="product-category">{product.category?.name}</p>
            
            <div className="product-description">
              <h3>Description</h3>
              <p>{product.description}</p>
            </div>

            <div className="product-specs">
              <h3>Specifications</h3>
              <ul>
                <li><strong>Material:</strong> {product.material}</li>
                {product.color && <li><strong>Color:</strong> {product.color}</li>}
                {product.dimensions && (
                  <li>
                    <strong>Dimensions:</strong>{' '}
                    {product.dimensions.width} x {product.dimensions.height} x {product.dimensions.depth} {product.dimensions.unit}
                  </li>
                )}
                {product.weight && <li><strong>Weight:</strong> {product.weight} lbs</li>}
              </ul>
            </div>

            <div className="product-actions">
              <a 
                href="tel:+918533964262" 
                className="btn btn-primary inquiry-btn"
              >
                Call for Inquiry
              </a>
              <a 
                href="https://wa.me/918533964262" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary whatsapp-btn"
              >
                WhatsApp Inquiry
              </a>
            </div>

            <div className="inquiry-note">
              <p>Contact us for pricing, availability, and custom options. We're here to help you find the perfect furniture!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
